import { Component } from '@angular/core';

@Component({
    selector: 'ca-narrow-page',
    templateUrl: 'narrow-page.component.html',
    styleUrls: ['./narrow-page.component.scss'],
    standalone: false
})
export class CaNarrowPage {}
